let store = null;

export const setStore = (reduxStore) => {
    store = reduxStore;
};

// Call this function to get the store state from anywhere in the application.
export const getStoreState = () => store?.getState();
